import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { createChain } from 'utils/api/chainApi'
import { createChainSchema } from 'utils/schema/chainSchema'
import { AxiosError } from 'axios'
import { PAGE_CHAIN_MGMT } from 'utils/constants'
import { Button } from 'components/common'
import { ChainDetailsForm } from 'components/chainManagement'
import BackButton from 'components/backButton'
import { useNavigate } from 'react-router-dom'
import { FileSourceType } from 'components/chainManagement/utils'

const CreateChainPage = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(createChainSchema) })

  const navigate = useNavigate()

  const handleCreateChain = async (data: any) => {
    const toastId = toast.loading('Creating chain...')
    try {
      const isChainFtp = data.fileSourceType === FileSourceType.CHAIN_FTP
      const isInternalFtp = data.fileSourceType === FileSourceType.INTERNAL_FTP
      const payload = {
        ...data,
        ftp: isChainFtp
          ? data.ftp
          : isInternalFtp
            ? { baseDirectory: data.ftp?.baseDirectory }
            : undefined,
      }

      await createChain(payload)
      reset()
      toast.success('Chain created successfully', { id: toastId })
      navigate(PAGE_CHAIN_MGMT.path)
    } catch (error) {
      if (error instanceof AxiosError) {
        const msg = error?.response?.data?.errors?.msg
        if (msg === 'CHAIN_ALREADY_EXISTS') {
          return toast.error('Chain with this ID already exists.', {
            id: toastId,
          })
        }
      }
      toast.error('Failed to create chain', { id: toastId })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleCreateChain)}>
        <ChainDetailsForm
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />

        <Button buttonText="Create Chain" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default CreateChainPage
